import { Suspense, lazy } from 'react';

import type { DynamicChartProps } from './DynamicChartImpl';

/**
 * A chart component string, executed.
 *
 * A thin lazy boundary: the runtime compiler (`react-live` + `sucrase`) is only
 * fetched once something actually renders a chart. The fallback is sized from the
 * scope's own height so the layout does not jump when it arrives.
 */
const Impl = lazy(() => import('./DynamicChartImpl'));

export function DynamicChart(props: DynamicChartProps) {
  const height = typeof props.scope.height === 'number' ? (props.scope.height as number) : 320;
  return (
    <Suspense fallback={<div className="skeleton w-full" style={{ height }} aria-hidden />}>
      <Impl {...props} />
    </Suspense>
  );
}

export type { DynamicChartProps };
